import { TerrainType } from '../world/terrain';

/**
 * Placeholder art palette (original, procedural). Swapping to real sprite
 * art later only touches render/; gameplay modules never import this file.
 */
export interface TerrainPalette {
  readonly base: string;
  readonly light: string;
  readonly dark: string;
  readonly accent: string;
}

/** Muted, dusty post-apocalyptic palette: nature reclaiming a dead world. */
export const TERRAIN_PALETTE: Record<TerrainType, TerrainPalette> = {
  [TerrainType.Grass]: { base: '#6b7a3d', light: '#7f8c4a', dark: '#525e2e', accent: '#97a05a' },
  [TerrainType.Meadow]: { base: '#8a8549', light: '#9d975a', dark: '#6c6838', accent: '#b8a35a' },
  [TerrainType.Dirt]: { base: '#7d6a50', light: '#8f7b5f', dark: '#62513c', accent: '#4f4232' },
  [TerrainType.Forest]: { base: '#3f5530', light: '#4c6338', dark: '#2f4224', accent: '#5b4a33' },
  [TerrainType.Rock]: { base: '#7c7a74', light: '#93918a', dark: '#5f5d58', accent: '#4c4a46' },
  [TerrainType.Water]: { base: '#3c5a58', light: '#4d6e69', dark: '#2c4543', accent: '#7f9d8f' },
  [TerrainType.Road]: { base: '#55524d', light: '#64615b', dark: '#43403c', accent: '#2f2d2a' },
  [TerrainType.Ruins]: { base: '#6e6a63', light: '#827d74', dark: '#54504a', accent: '#3b3833' },
};

export const UI_COLORS = {
  background: 0x15171a,
  hover: 0xf2ead2,
  select: 0xf0b43c,
  grid: 0x000000,
  skirtTop: '#4e4236',
  skirtBottom: '#26201b',
  infected: '#7c1f2a',
} as const;

/** Placement preview feedback. */
export const PLACEMENT_COLORS = {
  valid: 0x5fd068,
  invalid: 0xe0453a,
} as const;

/** Passability overlay tints (P). Chosen to stay distinguishable on every terrain colour. */
export const PASSABILITY_COLORS = {
  buildable: { color: 0x3fbf5a, alpha: 0.32, css: '#3fbf5a' },
  walkable: { color: 0xf2b233, alpha: 0.42, css: '#f2b233' },
  blocked: { color: 0xd8342a, alpha: 0.5, css: '#d8342a' },
} as const;

/** Owner colours (ground ring under buildings, HUD chips). Distinct under protanopia/deuteranopia by lightness too. */
export const OWNER_COLORS: Record<string, { color: number; css: string; label: string }> = {
  p1: { color: 0x3fa7ff, css: '#3fa7ff', label: 'Blue' },
  p2: { color: 0xe5484d, css: '#e5484d', label: 'Red' },
  p3: { color: 0x46c86a, css: '#46c86a', label: 'Green' },
  p4: { color: 0xc58af9, css: '#c58af9', label: 'Violet' },
  infected: { color: 0xb5c23a, css: '#b5c23a', label: 'Infected' },
  neutral: { color: 0x9a948a, css: '#9a948a', label: 'Neutral' },
};
